import { render, staticRenderFns } from "./CounterBadge.vue?vue&type=template&id=38b36bb7&scoped=true&"
import script from "./CounterBadge.vue?vue&type=script&lang=js&"
export * from "./CounterBadge.vue?vue&type=script&lang=js&"
import style0 from "./CounterBadge.vue?vue&type=style&index=0&id=38b36bb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b36bb7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38b36bb7')) {
      api.createRecord('38b36bb7', component.options)
    } else {
      api.reload('38b36bb7', component.options)
    }
    module.hot.accept("./CounterBadge.vue?vue&type=template&id=38b36bb7&scoped=true&", function () {
      api.rerender('38b36bb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CounterBadge.vue"
export default component.exports